import {QueryClientProvider} from '@tanstack/react-query';
import {Fragment, ReactNode} from 'react';

import {useCampaignTracking} from '@/features/campaign/hooks/useCampaignTracking';
import CookieConsentModal from '@/features/cookieConsentModal';
import {useShouldSkipInitScripts} from '@/shared/hooks/useShouldSkipInitScripts';
import queryClient from '@/shared/lib/react-query/queryClient';
import {useLanguage} from '@/shared/services/i18n';

import {useInternalAnalytics} from './hooks/useInternalAnalytics';
import {useRegisterFirebaseNotificationWorker} from './hooks/useRegisterFirebaseNotificationWorker';
import {useRollbar} from './hooks/useRollbar';

const App = ({children}: {children: ReactNode}) => {
  const skipInit = useShouldSkipInitScripts();
  const language = useLanguage();

  useRegisterFirebaseNotificationWorker({skipInit});
  useRollbar();
  useCampaignTracking();

  // Should use after useCampaignTracking ↑ to send a campaign to analytics
  useInternalAnalytics();

  return (
    <QueryClientProvider client={queryClient}>
      <Fragment key={language}>
        <CookieConsentModal />
        {children}
      </Fragment>
    </QueryClientProvider>
  );
};

export default App;
